import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

function StarRating({ rating, onRatingChange }) {
  return (
    <div className="flex space-x-1">
      {[...Array(5)].map((_, i) => {
        const value = i + 1;
        return (
          <button
            key={value}
            type="button"
            onClick={() => onRatingChange(value)}
            className="focus:outline-none"
          >
            <FontAwesomeIcon
              icon={faStar}
              className={`w-6 h-6 ${
                value <= rating ? "text-yellow-400" : "text-gray-300"
              }`}
            />
          </button>
        );
      })}
    </div>
  );
}

const Review = ({ bookingId }) => {
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const submitReview = async (e) => {
    e.preventDefault();
    if (!rating) {
      return alert("Please select a rating.");
    }
    setSubmitting(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/review`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bookingId, comment, rating }),
      });
      const data = await response.json();
      if (response.ok && data.review) {
        setSuccess(true);
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        console.error("Error submitting review:", data.message);
        alert(data.message || "There was an error submitting your review. Please try again.");
      }
    } catch (err) {
      console.error(err);
      alert("Network error. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="max-w-md mx-auto p-4 text-center">
        <div className="bg-green-50 border border-green-200 rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-green-800 mb-2">Thank You!</h2>
          <p className="text-green-700">Your review has been submitted successfully.</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submitReview} className="max-w-md mx-auto p-4 space-y-4">
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">Leave a Review</h1>
      <p className="text-gray-600 mb-4">Share your experience and help others make informed decisions.</p>
      
      <div>
        <label className="block mb-2 font-medium text-gray-700">Rating <span className="text-red-500">*</span></label>
        <StarRating rating={rating} onRatingChange={setRating} />
        {rating > 0 && (
          <p className="text-sm text-gray-500 mt-1">{rating} out of 5 stars</p>
        )}
      </div>
      
      <div>
        <label className="block mb-2 font-medium text-gray-700">Comment (Optional)</label>
        <textarea
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
          placeholder="Write your comments about your experience..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={4}
          disabled={submitting}
        />
      </div>
      
      <button
        type="submit"
        className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={submitting || rating === 0}
      >
        {submitting ? "Submitting..." : "Submit Review"}
      </button>
    </form>
  );
};

export default Review;
